<script setup>
import {
  ref, computed, watch, inject,
} from 'vue';
import SelectorUsuario from './SelectorUsuario.vue';
import SelectorParentesco from './SelectorParentesco.vue';
import ModalSimple from '../ModalSimple.vue';

const $I18n = inject('I18n');

const props = defineProps({
  name: { type: String, default: undefined },
  modelValue: { type: Array, default: undefined },
  tiposPermitidos: { type: Array, default: () => ([]) },
  placeholder: { type: String, default: 'Seleccione_usuario' },
  fullNameFormat: { type: Boolean, default: false },
  icon: { type: Boolean, default: false },
});

const emits = defineEmits(['update:modelValue']);

// Refs
const selectorUsuarios = ref(null);

// Data reactiva
const valueSelector = ref(props.modelValue || []);
const modalVisible = ref(false);

// Computed placeholder traducido
const placeholderTraducido = computed(() => $I18n.t(props.placeholder));

// Methods
const showModal = () => {
  modalVisible.value = true;
};

const hideModal = () => {
  modalVisible.value = false;
};

const aceptar = (parentescos) => {
  selectorUsuarios.value.addUsuarios(parentescos.map((parentesco) => parentesco.usuario));
  hideModal();
};

// Computed
const tipoParaSelector = computed(() => {
  // El selector de usuario solo soporta un tipo, solo filtramos si se ha configurado
  // el de parentesco con un tipo, si no que muestre todos los usuarios
  if (props.tiposPermitidos.length === 1) {
    return props.tiposPermitidos[0];
  }
  return null;
});

// Watchers
watch(valueSelector, (value) => {
  emits('update:modelValue', value);
});
</script>

<template>
  <div class="input-parentesco input-group">
    <SelectorUsuario
      ref="selectorUsuarios"
      v-model="valueSelector"
      :multiple="true"
      :placeholder="placeholderTraducido"
      :full-name-format="fullNameFormat"
      :tipo="tipoParaSelector"
      :icon="icon"
      :hide-selected="true"
      :internal-search="false"
    />
    <div class="input-group-btn">
      <button
        type="button"
        class="btn btn-cifra btn-new"
        @click="showModal()"
      >
        <i class="fa fa-user-plus"></i>
      </button>
    </div>
    <ModalSimple v-model="modalVisible">
      <SelectorParentesco
        :tipos-permitidos="tiposPermitidos"
        :full-name-format="fullNameFormat"
        :icon="true"
        @aceptar="aceptar($event)"
        @cancelar="hideModal()"
      />
    </ModalSimple>
    <select :name="name" multiple="true">
      <option
        v-for="valor in valueSelector"
        :key="valor"
        :value="valor"
        :selected="true"
      >
      </option>
    </select>
  </div>
</template>

<style lang="scss" scoped>
  .input-parentesco {
    select {
      display: none;
      visibility: hidden;
    }
    .input-group-btn {
      vertical-align: top;
    }
    .btn-new {
      border-radius: 0 3px 3px 0;
      padding-left: 8px;
      padding-right: 8px;
    }
  }
  :deep() {
    .v-select .dropdown-toggle .clear {
      visibility: visible;
    }
    .vs__dropdown-toggle {
      background-color: #fff;
      border-radius: 1px 0 0 1px;
      border-color: rgba(229, 230, 231, 1);
      min-height: 34px;
    }
    .vs__selected-options {
      max-height: 100px;
      overflow-y: scroll;
    }
    .vs__selected {
      border-radius: 1px;
    }
  }
</style>
